import pick from "lodash/pick";
import { havePermission } from "../../permissions";
import LAYERS_PERMISSIONS from "../../permissions/Layers.json";
import { selectedPolygonTypes } from "../Common/Constants";
import { flattenDeep } from "lodash";

const { DailyTrafficData } = selectedPolygonTypes;

const getDailyTrafficRange = data => {
	const min = Math.min(...data.map(obj => obj.population));
	const max = Math.max(...data.map(obj => obj.population));
	return { min, max };
};

const getDailyTrafficPolygon = locations => {
	// senect 10 random locations
	// locations = locations.slice(0, 100);
	return {
		polygons: locations.map((obj, ind) => {
			const { popular_times_past_years, popular_times, population, sec, motor_sports_population } = obj;
			return {
				id: ind,
				_id: ind,
				coordinates: obj.coordinates,
				style: {
					fillColor: popular_times ? "#FF000077" : "#FFA500",
					strokeColor: "#00000055",
					zindex: 10
				},
				filterData: {
					motor_sports_population,
					popular_times,
					popular_times_past_years,
					population,
					sec
				},

				polygonClick: true,
				type: DailyTrafficData
			};
		})
	};
};

const getDailyTrafficPerHourRange = data => {
	const popular_times = data
		.map(obj => {
			if (!obj.popular_times) return [];

			const { popular_times } = obj;

			let allValues = popular_times.map(({ data }) => {
				return data;
			});

			return flattenDeep(allValues);
		})
		.filter(obj => obj.length > 0);
	// get the max and min of the popular times
	const min = Math.min(...popular_times.map(obj => Math.min(...obj)));
	const max = Math.max(...popular_times.map(obj => Math.max(...obj)));
	// const min = Math.min(...data.map(obj => obj.population));
	// const max = Math.max(...data.map(obj => obj.population));

	return { min, max };
};

const getDailyTrafficSlider = ({ locations, dispatch }) => {
	if (!havePermission(LAYERS_PERMISSIONS.LAYER_DAILY_TRAFFIC_DATA_SLIDER)) return null;
	// const { min, max } = getDailyTrafficRange(locations);
	// eslint-disable-next-line no-unused-vars
	const { min: trafficMin, max: trafficMax } = getDailyTrafficPerHourRange(locations);
	const trafficSlider = {
		min: trafficMin,
		max: trafficMax,
		sliderHandler: value => {
			dispatch({ type: "filterPolygons", value: { value, type: `${DailyTrafficData}-trafficData` } });
		},
		type: `${DailyTrafficData}-trafficData`,
		isRange: false,
		ranges: [
			{
				text: "All",
				value: [0, 100]
			},
			{
				text: "No Traffic",
				value: [0, 9]
			},
			{
				text: "Light Traffic",
				value: [10, 39]
			},
			{
				text: "Moderate Traffic",
				value: [40, 69]
			},
			{
				text: "Heavy Traffic ",
				value: [70, 100]
			}
		]
	};

	const weeklySlider = {
		min: 0,
		max: 6,
		sliderHandler: value => {
			dispatch({ type: "filterPolygons", value: { value, type: `${DailyTrafficData}-weeklyData` } });
		},
		type: `${DailyTrafficData}-weeklyData`,
		sliderType: "weekly"
	};

	// const populationSlider = {
	// 	min,
	// 	max,
	// 	sliderHandler: value => {
	// 		dispatch({ type: "filterPolygons", value: { value, type: `${DailyTrafficData}-populationData` } });
	// 	},
	// 	type: `${DailyTrafficData}-populationData`
	// };

	// const populationSlider = {
	// 	min,
	// 	max,
	// 	sliderHandler: value => dispatch({ type: "filterPolygons", value: { value, type: PopulationGrids } }),
	// 	type: PopulationGrids
	// };

	const hourlySlider = {
		min: 0,
		max: 23,
		sliderHandler: value => {
			dispatch({ type: "filterPolygons", value: { value, type: `${DailyTrafficData}-hourlyData` } });
		},
		type: `${DailyTrafficData}-hourlyData`,
		sliderType: "hourly"
	};

	return [weeklySlider, hourlySlider, trafficSlider];
};

const DailyTrafficDataService = {
	all: ({ locations, type, sliderHandler, dispatch }) => {
		return {
			...pick(getDailyTrafficPolygon(locations), ["polygons"]),
			slider: getDailyTrafficSlider({ sliderHandler, locations, type, dispatch })
		};
	},
	polygons: ({ locations }) => {
		return pick(getDailyTrafficPolygon(locations), ["polygons"]);
	}
};

export default DailyTrafficDataService;
export { getDailyTrafficPolygon, getDailyTrafficSlider, getDailyTrafficRange };
